export default "__VITE_ASSET__CmZp_BYw__"